export const DEFAULT_TEMPLATE_CATEGORY = 'Most Popular';
